import React from 'react'
import { Route } from 'react-router-dom'
import { PaymentForm } from '../PaymentForm'
import { StandardLayout } from 'common/layouts/StandardLayout'

export const routes = (
  <Route path='/subscriptions/new'>
    <StandardLayout>
      <PaymentForm />
    </StandardLayout>
  </Route>
)
